import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const handleSuccess = (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      // Store the Google ID token for API calls
      localStorage.setItem('adminToken', credentialResponse.credential);
      localStorage.setItem('adminAuth', JSON.stringify({
        credential: credentialResponse.credential,
        expiresAt: Date.now() + 3600000, // 1 hour
      }));
      
      navigate('/admin');
    }
  };

  const handleError = () => {
    console.error('Google login failed');
    setError('Login failed. Ensure you have admin access.');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/simplytechwise-logo.png" alt="Simply TechWise" className="h-12 mx-auto mb-3" />
          <h1 className="text-2xl font-bold text-gray-800">WiseAssist Admin</h1>
          <p className="text-gray-500 mt-1">Google Workspace sign-in required</p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6">
          {error && (
            <div className="mb-4 p-3 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}

          <div className="flex justify-center">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              useOneTap
              theme="filled_blue"
              size="large"
              text="signin_with"
              shape="rectangular"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
